import {Component} from 'react'
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom'

import LoginForm from './components/LoginForm'
import Home from './components/Home'
import Products from './components/Products'
import ProductItemDetails from './components/ProductItemDetails'
import Cart from './components/Cart'
import NotFound from './components/NotFound'
import ProtectedRoute from './components/ProtectedRoute'
import CartContext from './context/CartContext'

import './App.css'

class App extends Component {
  state = {
    cartList: [],
    totalAmount: 0,
  }

  addCartItem = product => {
    const {cartList, totalAmount} = this.state
    console.log(product.price, 'price')
    const updatedTotalAmount = totalAmount + product.price

    const existingCartItemIndex = cartList.findIndex(
      item => item.id === product.id,
    )
    const existingCartItem = cartList[existingCartItemIndex]
    let updatedItems

    if (existingCartItem) {
      const updatedItem = {
        ...existingCartItem,
        price: existingCartItem.price + product.price,
        quantity: existingCartItem.quantity + 1,
      }
      updatedItems = [...cartList]
      updatedItems[existingCartItemIndex] = updatedItem
    } else {
      updatedItems = cartList.concat(product)
    }
    console.log('updatedItems', updatedItems)
    this.setState(() => ({
      cartList: [...updatedItems],
      totalAmount: updatedTotalAmount,
    }))
  }

  deleteCartItem = id => {
    console.log(id)
    const {cartList, totalAmount} = this.state

    const existingCartItemIndex = cartList.findIndex(item => item.id === id)
    const existingItem = cartList[existingCartItemIndex]
    console.log(existingItem.price)
    console.log(existingItem.quantity)
    const eachPrice = existingItem.price / existingItem.quantity
    const updatedTotalAmount =
      totalAmount - existingItem.price / existingItem.quantity
    let updatedItems
    if (existingItem.quantity === 1) {
      updatedItems = cartList.filter(item => item.id !== id)
    } else {
      const updatedItem = {
        ...existingItem,
        quantity: existingItem.quantity - 1,
        price: existingItem.price - eachPrice,
      }
      updatedItems = [...cartList]
      updatedItems[existingCartItemIndex] = updatedItem
    }
    this.setState(() => ({
      cartList: [...updatedItems],
      totalAmount: updatedTotalAmount,
    }))
  }

  render() {
    const {cartList, totalAmount} = this.state
    console.log(cartList, totalAmount, 'cartList and total items')

    return (
      <BrowserRouter>
        <CartContext.Provider
          value={{
            cartList,
            addCartItem: this.addCartItem,
            deleteCartItem: this.deleteCartItem,
            totalAmount,
          }}
        >
          <Switch>
            <Route exact path="/login" component={LoginForm} />
            <ProtectedRoute exact path="/" component={Home} />
            <ProtectedRoute exact path="/products" component={Products} />
            <ProtectedRoute
              exact
              path="/products/:id"
              component={ProductItemDetails}
            />
            <ProtectedRoute exact path="/cart" component={Cart} />
            <Route path="/not-found" component={NotFound} />
            <Redirect to="not-found" />
          </Switch>
        </CartContext.Provider>
      </BrowserRouter>
    )
  }
}

export default App
